import { BASE_QUERY_KEY } from '@client-app-sdk/utils/constants';
import { useQuery } from '@tanstack/react-query';
import useAccessRequestTemplatesApi from './use-access-request-templates-api';
import { AccessRequestTemplatesApiGetAccessRequestTemplateRequest } from '@client-app-sdk';

const QUERY_KEY = 'getAccessRequestTemplate';

export default function useGetAccessRequestTemplate({
  id,
  filterAvailable = true,
}: AccessRequestTemplatesApiGetAccessRequestTemplateRequest) {
  const api = useAccessRequestTemplatesApi();

  const fetchRequestTemplate = async () => {
    const request = await api.getAccessRequestTemplate({ id, filterAvailable });
    return request;
  };

  return useQuery([BASE_QUERY_KEY, QUERY_KEY, id, filterAvailable], fetchRequestTemplate);
}
